import React, { useEffect, useState } from "react";
import { useAppContext } from "../../context/AppContext";

const Header = () => {
  const { state } = useAppContext();

  const handleToggleSidebar = () => {
    // Your toggle sidebar logic here
    window.clickToggleSidebarIconMobile();
    console.log("Sidebar toggled!");
  };
  // const [userData, setUserData] = useState({
  //   name: "",
  //   email: "",
  // });

  // useEffect(() => {
  //   setUserData({
  //     name: JSON.parse(localStorage.getItem("full_name")),
  //     email: JSON.parse(localStorage.getItem("email")),
  //   });
  // }, []);

  const [userData, setUserData] = useState(() => {
    try {
      return {
        // name: JSON.parse(localStorage.getItem("full_name") || '""'),
        // email: JSON.parse(localStorage.getItem("email") || '""'),
        name: state?.user?.full_name,
        email: state?.user?.email,
      };
    } catch {
      return { name: "", email: "" };
    }
  });

  return (
    <div className="main-header">
      <div className="main-header-logo">
        {/* Logo Header */}
        <div className="logo-header" data-background-color="dark">
          <a href="/blogs" className="logo">
            <img
              // src="/icon/main-logo.png"
              src="/logo.webp"
              alt="navbar brand"
              className="navbar-brand"
              height="20"
            />
          </a>
          <div className="nav-toggle">
            <button
              className="btn btn-toggle toggle-sidebar"
              onClick={handleToggleSidebar}
            >
              <i className="gg-menu-right"></i>
            </button>
            <button
              className="btn btn-toggle sidenav-toggler"
              onClick={handleToggleSidebar}
            >
              <i className="gg-menu-left"></i>
            </button>
          </div>
          <button className="topbar-toggler more">
            <i className="gg-more-vertical-alt"></i>
          </button>
        </div>
        {/* End Logo Header */}
      </div>
      {/* Navbar Header */}
      <nav className="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom">
        <div className="container-fluid">
          <ul className="navbar-nav topbar-nav ms-md-auto align-items-center">
            {/* Search Icon */}
            <li className="nav-item topbar-icon dropdown hidden-caret d-flex d-lg-none">
              <a
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-expanded="false"
                aria-haspopup="true"
              >
                <i className="fa fa-search"></i>
              </a>
              <ul className="dropdown-menu dropdown-search animated fadeIn">
                <form className="navbar-left navbar-form nav-search">
                  <div className="input-group">
                    <input
                      type="text"
                      placeholder="Search ..."
                      className="form-control"
                    />
                  </div>
                </form>
              </ul>
            </li>

            {/* User Profile */}
            <li className="nav-item topbar-user dropdown hidden-caret">
              <a
                className="dropdown-toggle profile-pic"
                data-bs-toggle="dropdown"
                href="#"
                aria-expanded="false"
              >
                <div className="avatar-sm">
                  <img
                    src="/assets/img/blank-avatar.jpg"
                    alt="..."
                    className="avatar-img rounded-circle"
                  />
                </div>
                <span className="profile-username">
                  <span className="op-7">Hi,</span>
                  {/* <span className="fw-bold">Admin</span> */}
                  <span className="fw-bold">{userData?.name}</span>
                </span>
              </a>
              <ul className="dropdown-menu dropdown-user animated fadeIn">
                <div className="dropdown-user-scroll scrollbar-outer">
                  <li>
                    <div className="user-box">
                      <div className="avatar-lg">
                        <img
                          src="/assets/img/blank-avatar.jpg"
                          alt="image profile"
                          className="avatar-img rounded"
                        />
                      </div>
                      <div className="u-text">
                        {/* <h4>Admin</h4> */}
                        <h4>{userData?.name}</h4>

                        {/* <p className="text-muted">admin@bigscreensocial.app</p> */}
                        <p className="text-muted">{userData?.email}</p>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="/logout">
                      Logout
                    </a>
                  </li>
                </div>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
      {/* End Navbar */}
    </div>
  );
};

export default Header;
